/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface CorporateAgreementInfoVO {
  /**
   * corporate name
   */
  corporateName?: string;
  /**
   * corporate id
   */
  id?: string;
  /**
   * secure rate id for discount
   */
  secureRateId?: string;
  /**
   * type code of corporate agreement programs, e.g. Exclusive discount program - "CNA"
   */
  typeCode?: string;
}
